import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z","key":"svg-0"}]]

const IconBrandGitlab = createReactComponent('outline', 'brand-gitlab', 'BrandGitlab', __iconNode);

export default IconBrandGitlab;